import React from 'react';
import PropTypes from 'prop-types';

import DocumentStoreItem from '../../models/document_store_item';
import DocumentMetadataFieldsInputGroup from '../form/document_metadata_fields_input_group.jsx';
import DocumentLocks from '../../constants/document_locks';

import { documentIsLockedBy } from '../../helpers/document_lock_helper';

import DocumentSubmitDataContainers from '../../constants/document_submit_data_containers';
import { DocumentActions } from '../../reflux/document_store';



import { generateUUID } from '../../../utils/uuid';

export default class EditDocumentForm extends React.Component {

	static propTypes = {
		id: PropTypes.string,
		name: PropTypes.string,
		store: PropTypes.object
	};

	static defaultProps = {
		id: '',
		name: '',
		store: new DocumentStoreItem()
	};

	constructor(props) {
		super(props);
		this.downloadDocumentFile = this.downloadDocumentFile.bind(this);
		this.setSubmitDataFileField = this.setSubmitDataFileField.bind(this);
		this.setSubmitDataField = this.setSubmitDataField.bind(this);
	}

	componentDidMount() {
		this.setSubmitDataField("version", null, this.getMinorVersionValue());

		setTimeout(() => {
			let modalDocEdit = $('.dados-document-modal-edit');
			if(modalDocEdit.is(':visible') === true){
				let btnCloseEditDoc = $('.button-close-modal-document');
				btnCloseEditDoc.off('keydown');
				btnCloseEditDoc.keypress((e) => {
					e.currentTarget.click();
				})

				this.tabButtons();
			}

			this.tabCheckout();
			this.tabRadioButton();
		}, 1000);
	}

	componentDidUpdate(){
		setTimeout(() => {
			this.focusCloseModal();
			this.tabModalCheckout();
			this.tabRadioButton();
		}, 800);
	}

	tabButtons(){
		let btnCancel = $('#btn-cancel-checkout-document');
		if(btnCancel.is(':visible')){
			btnCancel.off('keydown');
		}
	}

	tabRadioButton(){
		let idDivRadio = `input__document_version_${this.props.id}`;

		$(`#${idDivRadio} .input-checkbox-group p label`).attr('tabindex', 0);
		$(`#${idDivRadio} .input-checkbox-group p label`).keydown((e) => {
			e.which === 32 && e.currentTarget.click();
		});
	}

	tabCheckout(){
		const modal = $("#documentModal");
		let cloudDonwload = $('.cloud_donwload');
		let btnCancel = $('#btn-cancel-checkout-document');
		let btnCheckinDoc = $('#btn-checkin-document');

		cloudDonwload.attr('tabindex', 0).focus();
		btnCancel.attr('tabindex', 0);
		btnCheckinDoc.attr('tabindex', 0);

		cloudDonwload.keydown((e) => {
			e.which === 13 && e.currentTarget.click();
		});


		btnCheckinDoc.keydown((e) => {
			e.which === 13 && $('#btn-checkin-document')[0].click();

			if(e.shiftKey){
				if(e.shiftKey && e.keyCode === 9)
					return true
			}

			if(e.which === 9 || e.keyCode === 9 ){
				modal.find('h5-custom').focus();
				return false
			}
		});
	}

	tabModalCheckout(){
		const modal = $("#documentModal");
		let btnFileField = $('.input-document-checkout .file-field .button');
		let inputFileField = $('.input-document-checkout .file-field .button input');
		let filePath = $('.input-document-checkout .file-path');
		btnFileField.attr('tabindex', 0).focus();

		btnFileField.keydown((e) => {
			if(e.which === 13) inputFileField.click();
		})

		filePath.attr('tabindex', -1);
	}

	focusCloseModal(){
		const modal = $("#documentModal");
		let modalEditDoc = $('.dados-document-modal-edit');
		let btnCancelCheckoutDoc =$('#btn-cancel-checkout-document');
		let btnDocumentCheckout = $('#btn-document-checkout');
		if(modalEditDoc.is(':visible') === false){
			btnCancelCheckoutDoc.off('keydown');
			btnDocumentCheckout.keydown((e) => {
				if(e.which === 9 || e.keyCode === 9 ){
					modal.find('h5-custom').focus();
					return false
				}
			});
		}
	}

	get document() {
		return this.props.store.document;
	}

	get checkinSubmitData() {
		return this.props.store.submitData[DocumentSubmitDataContainers.CHECKIN];
	}

	get template() {
		return this.props.store.template;
	}

	get currentVersion() {
		return this.checkinSubmitData && this.checkinSubmitData.version;
	}

	setSubmitDataFileField(event) {
		const fileFieldKey = `${DocumentSubmitDataContainers.CHECKIN}.file`;
		const fileFieldData = event.target.files[0];

		let splitNameFile = fileFieldData.name.split('.');
		let lengthSplit = splitNameFile.length -1;
		let typeFile = splitNameFile[lengthSplit];

		let allowedFileTypes = this.props.store.template.allowedFileTypes;
		let maxFileSizeAllowed = this.props.store.template.maxFileSizeAllowed;

		let validateType = allowedFileTypes.length > 0 ? allowedFileTypes.includes(typeFile) : null;
		let sizeFile = fileFieldData.size / 1024;
		let validateSize = sizeFile > maxFileSizeAllowed;

		if(validateType === false && maxFileSizeAllowed === null){
			DocumentActions.displayFlashMessage(this.props.id, {type: 'error', message: Realize.i18n.t(`template.messages.allowedFileTypes`).replace('@@type@@', allowedFileTypes)})
		} else if(validateType === false && maxFileSizeAllowed !== null && validateSize === true){
			DocumentActions.displayFlashMessage(this.props.id, {type: 'error', message: Realize.i18n.t(`template.messages.allowedFileTypesSize`).replace('@@type@@', allowedFileTypes).replace('##size##', maxFileSizeAllowed)});
		} else if((validateType === null || validateType === true) && maxFileSizeAllowed !== null && validateSize === true){
			DocumentActions.displayFlashMessage(this.props.id, {type: 'error', message: Realize.i18n.t(`template.messages.maxFileSizeAllowed`).replace('##size##', maxFileSizeAllowed)});
		} else {
			DocumentActions.dismissFlashMessage(this.props.id);
		}

		DocumentActions.setSubmitDataField(this.props.id, fileFieldKey, fileFieldData);
		return false;
	}

	setSubmitDataField(fieldKey, event, fieldValue) {
		const dataFieldValue = Array.isArray(fieldValue) ? fieldValue[0] : fieldValue;
		const dataFieldKey = `${DocumentSubmitDataContainers.CHECKIN}.${fieldKey}`;

		DocumentActions.setSubmitDataField(this.props.id, dataFieldKey, dataFieldValue);
		return false;
	}

	documentWasDownloaded() {
		return this.props.store.documentDownloaded;
	}

	documentIsLockedToOverride() {
		return documentIsLockedBy(this.document, DocumentLocks.OVERRIDE);
	}

	downloadDocumentFile() {
		const inputDocumentValue = {
			fileName: this.document.fileName || '',
			fileUUID: this.document.fileUUID || ''
		};

		return DocumentActions.downloadDocumentFile(this.props.id, inputDocumentValue);
	}

	getMinorVersionValue() {
		return this.document.version.minorVersion;
	}

	buildVersionFieldId() {
		return `document_version_${this.props.id}`;
	}

	buildVersionOptions() {
		const version = this.document.version;

		return [
			// this.buildCurrentVersionOption(version),
			this.buildMinorVersionOption(version),
			this.buildMajorVersionOption(version)
		];
	}

	buildCurrentVersionOption(version) {
		const suffix = ` - ${Realize.i18n.t('overwrite')}`;
		return this.buildVersionOption(version.currentVersion, suffix, this.documentIsLockedToOverride());
	}

	buildMinorVersionOption(version) {
		return this.buildVersionOption(version.minorVersion);
	}

	buildMajorVersionOption(version) {
		return this.buildVersionOption(version.majorVersion);
	}

	buildVersionOption(version, suffix = '', disabled = false) {
		return {
			name: `v${version}${suffix}`,
			value: version,
			disabled
		};
	}

	acceptTypeFile(){
		let allowedFileTypes = this.props.store.template.allowedFileTypes;
		let joinFileTypes = allowedFileTypes.join(', .');

		if(joinFileTypes !== "")
			return `.${joinFileTypes}`;
	}

	renderFileInput() {
		setTimeout(()=>{
			$("input[type=file]").attr('tabindex', -1);
		}, 0);

		return (
			<Input
				label={Realize.i18n.t('template.attributes.fileName')}
				component="file"
				className="col l12 m12 s12 input-document-checkout"
				onChange={this.setSubmitDataFileField}
				accept={this.acceptTypeFile()}
			/>
		);
	}

	renderFileDownloadButton() {
		return (
			<div className="edit-document__download_button col s12 m12 l12">
			<Button
				name={Realize.i18n.t('template.actions.downloadDocument')}
				icon="cloud_download"
				element="a"
				style="primary"
				role='button'
				onClick={this.downloadDocumentFile}
				className="cloud_donwload"
			/>
			</div>
		);
	}

	renderVersionRadioGroup() {
		return (
			<Input
				label={Realize.i18n.t('template.attributes.version')}
				component="radio_group"
				currentValue={this.currentVersion}
				id={this.buildVersionFieldId()}
				name={this.buildVersionFieldId()}
				options={this.buildVersionOptions()}
				onChange={this.setSubmitDataField.bind(this, "version")}
				key={generateUUID()}
			/>
		);
	}

	renderMetadata() {
		//verifica se veio algum campo
		var empty = true;
		for (let field in this.template.fields) {
			if (hasOwnProperty.call(this.template.fields, field)) {
				empty = false;
				break;
			}
		}

		if (empty) return;

		return (
			<div>
				<h5 className="edit-document-form__header" tabIndex="0">
					{Realize.i18n.t('template.titles.documentFields')}
				</h5>
				<div className="edit-document-form__fields row fields-document-edit">
					<DocumentMetadataFieldsInputGroup
						{...this.props}
						containerId={DocumentSubmitDataContainers.CHECKIN}
						editMode={true} />
				</div>
			</div>
		)
	}

	render() {
		return (
			<div className="edit-document-form__wrapper dados-document-modal-edit">
				<h5 className="edit-document-form__header" tabIndex="0">
					{Realize.i18n.t('template.titles.fileData')}
				</h5>
				<div className="edit-document-form__fields row">
					{this.documentWasDownloaded() ? this.renderFileInput() : this.renderFileDownloadButton()}
					{this.renderVersionRadioGroup()}
				</div>

				{this.renderMetadata()}
			</div>
		);
	}
}
